var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserManagementInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#EDEDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 22.6663C12.3183 22.6663 9.3335 19.6815 9.3335 15.9997C9.3335 12.3178 12.3183 9.33301 16.0002 9.33301C19.682 9.33301 22.6668 12.3178 22.6668 15.9997C22.6668 19.6815 19.682 22.6663 16.0002 22.6663ZM16.0002 21.333C18.9457 21.333 21.3335 18.9452 21.3335 15.9997C21.3335 13.0542 18.9457 10.6663 16.0002 10.6663C13.0546 10.6663 10.6668 13.0542 10.6668 15.9997C10.6668 18.9452 13.0546 21.333 16.0002 21.333ZM14.0002 13.9997H15.3335V17.9997H14.0002V13.9997ZM16.6668 13.9997H18.0002V17.9997H16.6668V13.9997Z",
    fill: "#97999B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserManagementInactive);
export default __webpack_public_path__ + "static/media/UserManagementInactive.f04231c51eaa560a1752cdfee44dc73e.svg";
export { ForwardRef as ReactComponent };